import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDueDate, getDueDateStatus } from '../../utils/taskDateUtils';
import styles from './TaskMetadata.module.css';

const TaskMetadata = ({ dueDate, dueDateSemantics, tags, isComplete }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || i18n.language;
  const dueDateTimeZone =
    typeof dueDateSemantics?.timezone === 'string'
      ? dueDateSemantics.timezone
      : undefined;

  if (!dueDate && (!tags || tags.length === 0)) {
    return null;
  }

  const dueDateStatus = dueDate
    ? getDueDateStatus(dueDate, { timeZone: dueDateTimeZone })
    : null;
  const formattedDueDate = dueDate
    ? formatDueDate(dueDate, isComplete, { locale, timeZone: dueDateTimeZone, t })
    : null;

  return (
    <div className={styles.metadata}>
      {/* Due date */}
      {formattedDueDate && (
        <div className={`${styles.dueDate} ${isComplete ? '' : styles[dueDateStatus]}`}>
          {isComplete ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          ) : dueDateStatus === 'overdue' ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          )}
          <span>{formattedDueDate}</span>
        </div>
      )}

      {/* Tags */}
      {tags && tags.length > 0 && (
        <div className={styles.tags}>
          {tags.map((tag, index) => (
            <span key={index} className={styles.tag}>
              #{tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TaskMetadata;
